import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '../../common/current-user/current-user.service';

export const sandboxBillingGuard: CanActivateFn = () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  return currentUserService.canAccessSandboxBilling()
    ? true
    : router.createUrlTree(['/dashboard']);
};
